/* VIMA — animation au défilement de la coque à dos interchangeable (section « Coque interchangeable »). */
(function () {
  'use strict';
  if (window.__vimaStory) return; window.__vimaStory = true;
  var STILL = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[<&>"]/g, function (c) { return { '<': '&lt;', '&': '&amp;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var clamp = function (x, a, b) { a = a == null ? 0 : a; b = b == null ? 1 : b; return Math.min(b, Math.max(a, x)); };
  var easeOut = function (x) { return 1 - Math.pow(1 - x, 3); };
  var easeIn = function (x) { return x * x * x; };
  var smooth = function (x) { return x * x * (3 - 2 * x); };
  var hexRGB = function (h) { h = String(h || '#000000').replace('#', ''); if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join(''); return [0, 2, 4].map(function (i) { return parseInt(h.slice(i, i + 2), 16) || 0; }); };
  var mix = function (a, b, k) { var P = hexRGB(a), Q = hexRGB(b); return P.map(function (v, i) { return Math.round(v + (Q[i] - v) * k); }); };
  var lerp = function (A, B, k) { var r = {}; for (var key in A) r[key] = A[key] + (B[key] - A[key]) * k; return r; };
  var POSE = {
    FROM: { x: -150, y: 6, z: 260, rx: 4, ry: 46, rz: -18, o: 0 }, HOVER: { x: 0, y: -2, z: 105, rx: 0, ry: 0, rz: 0, o: 1 },
    ATT: { x: 0, y: 0, z: 0, rx: 0, ry: 0, rz: 0, o: 1 }, LIFT: { x: 10, y: -3, z: 130, rx: -8, ry: -18, rz: 5, o: 1 },
    AWAY: { x: 175, y: -8, z: 60, rx: -6, ry: -42, rz: 18, o: 0 }
  };
  /* Dos détachable : contour exact du panneau, relevé sur la photo (repères 200 × 410). */
  var PLATE_PATH = 'M96.2 5.6 H168.4 A25 25 0 0 1 193.4 30.6 V377.3 A25 25 0 0 1 168.4 402.3 H32 A25 25 0 0 1 7 377.3 V98 C7.1 97.4 7.0 95.5 7.4 94.6 C7.8 93.7 8.5 92.7 9.3 92.4 C10.1 92.1 10.8 91.9 12.2 92.6 C13.6 93.3 15.7 95.4 17.5 96.5 C19.3 97.6 21.3 98.5 23.1 99.2 C24.9 99.9 26.1 100.2 28.5 100.6 C30.9 101.0 33.7 101.3 37.6 101.5 C41.5 101.7 47.3 101.7 52 101.7 C56.7 101.7 62.0 101.8 66 101.6 C70.0 101.4 73.2 101.3 75.9 100.8 C78.6 100.3 80.0 99.8 82 98.9 C84.0 98.0 86.4 96.7 88.1 95.5 C89.8 94.3 90.8 93.3 92 92 C93.3 90.8 94.5 89.4 95.6 88 C96.7 86.6 97.6 85.3 98.6 83.4 C99.6 81.5 100.7 78.7 101.4 76.5 C102.1 74.3 102.5 72.4 102.8 70 C103.1 67.6 103.0 63.3 103 62 L103 36 C102.9 34.8 103.0 31.1 102.6 28.8 C102.2 26.5 101.5 24.0 100.8 22 C100.1 20.0 99.4 18.6 98.6 17 C97.8 15.4 96.7 13.8 96 12.5 C95.3 11.2 94.7 9.9 94.5 9 C94.3 8.1 94.3 7.6 94.6 7 C94.9 6.4 95.9 5.8 96.2 5.6 Z';

  /* Dessin sur <canvas> (et non en SVG) : Safari affiche mal le SVG à l'intérieur d'une animation 3D. */
  var FLAT_ALL = false;
  var RES = 3; /* 600 × 1230 px */
  function makeCanvas() { var c = document.createElement('canvas'); c.width = 200 * RES; c.height = 410 * RES; var x = c.getContext('2d'); x.scale(RES, RES); return c; }
  function roundRect(x, w, h, r) { x.beginPath(); x.moveTo(r, 0); x.arcTo(w, 0, w, h, r); x.arcTo(w, h, 0, h, r); x.arcTo(0, h, 0, 0, r); x.arcTo(0, 0, w, 0, r); x.closePath(); }
  function loadImg(src, cb) { if (!src) return; var i = new Image(); i.decoding = 'async'; i.onload = function () { cb(i); }; i.src = src; }
  function shellCanvas(shellUrl) {
    var c = makeCanvas(), x = c.getContext('2d'), plate = new Path2D(PLATE_PATH);
    var paintInside = function () {
      var g = x.createLinearGradient(0, 0, 200, 410); g.addColorStop(0, '#26262A'); g.addColorStop(1, '#121214');
      x.fillStyle = g; x.fill(plate); x.lineWidth = 3.2; x.lineJoin = 'round'; x.strokeStyle = '#17171A'; x.stroke(plate);
      x.beginPath(); x.arc(100, 212, 66, 0, Math.PI * 2); x.lineWidth = 9; x.strokeStyle = '#0B0B0C'; x.stroke();
      if (x.setLineDash) x.setLineDash([2, 3]); x.lineWidth = 1; x.strokeStyle = '#3A3A3F'; x.stroke(); if (x.setLineDash) x.setLineDash([]);
      x.fillStyle = '#0B0B0C'; x.fillRect(95, 290, 10, 22);
    };
    x.save(); roundRect(x, 200, 410, 38); x.clip(); x.fillStyle = '#1C1C1F'; x.fill(); paintInside(); x.restore();
    loadImg(shellUrl, function (im) { x.save(); roundRect(x, 200, 410, 38); x.clip(); x.drawImage(im, 0, 0, 200, 410); paintInside(); x.restore(); });
    return c;
  }
  /* full = true : l'image couvre toute la coque (fichier d'impression ou photo de la coque), sinon recadrée sur le panneau. */
  function plateCanvas(img, full) {
    var c = makeCanvas(), x = c.getContext('2d'), plate = new Path2D(PLATE_PATH);
    var gloss = function () { var g = x.createLinearGradient(0, 0, 200, 410); g.addColorStop(0, 'rgba(255,255,255,.22)'); g.addColorStop(0.3, 'rgba(255,255,255,0)'); g.addColorStop(1, 'rgba(0,0,0,.08)'); x.fillStyle = g; x.fillRect(0, 0, 200, 410); };
    x.save(); x.clip(plate); x.fillStyle = '#EDEAE3'; x.fillRect(0, 0, 200, 410); gloss(); x.restore();
    loadImg(img, function (im) {
      x.save(); x.clip(plate);
      if (full) x.drawImage(im, 0, 0, 200, 410);
      else { var r = Math.max(186 / im.width, 397.5 / im.height), w = im.width * r, h = im.height * r; x.drawImage(im, 7 + (186 - w) / 2, 5.5 + (397.5 - h) / 2, w, h); }
      gloss(); x.restore();
    });
    return c;
  }

  /* Mode Safari : chaque couche d'épaisseur est recalculée en perspective (décalage + hauteur),
     pour que le côté de la coque reste aligné sur ses angles, comme une vraie coque vue de biais. */
  function flatDepth(els, w, ry) {
    var P = 1600, D = w * 0.13, a = ry * Math.PI / 180, c = Math.cos(a), s = Math.sin(a), xe = (ry < 0 ? 1 : -1) * w / 2;
    els.forEach(function (el, k) {
      var d = (k + 1) / els.length * D, zt = -xe * s - d * c, A = (xe * c - d * s) / (P - zt);
      var xf = A * P / (c - A * s), sy = (P + xf * s) / (P - zt);
      el.style.transform = 'translateX(' + ((xf - xe) * xe > 0 ? xf - xe : 0).toFixed(2) + 'px) scaleY(' + sy.toFixed(4) + ')';
    });
  }

  /* Mode Safari : motifs déplacés en 2D (taille selon la distance, ordre d'empilement par z-index).
     Safari coupe sinon les motifs qui se croisent en 3D (un motif à moitié devant, à moitié derrière un autre). */
  function plateTransform(p) {
    if (!FLAT_ALL) return 'translate3d(' + p.x + '%,' + p.y + '%,' + p.z + 'px) rotateX(' + p.rx + 'deg) rotateY(' + p.ry + 'deg) rotateZ(' + p.rz + 'deg)';
    var k = 1600 / (1600 - p.z), r = Math.PI / 180;
    return 'translate(' + p.x + '%,' + p.y + '%) rotate(' + p.rz + 'deg) scale(' + (k * Math.cos(p.ry * r)).toFixed(4) + ',' + (k * Math.cos(p.rx * r)).toFixed(4) + ')';
  }

  function init(root, n) {
    var cfgEl = root.querySelector('[data-story-config]'); if (!cfgEl) return;
    var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    /* Adresses Shopify « //cdn… » rendues complètes pour les images utilisées dans le SVG. */
    var abs = function (u) { return /^\/\//.test(u || '') ? location.protocol + u : u; };
    cfg.shell = abs(cfg.shell);
    var backs = (cfg.backs || []).filter(function (b) { return b && b.img; }).map(function (b) { b.img = abs(b.img); return b; });
    if (!backs.length) { root.style.display = 'none'; return; }
    var q = function (s) { return root.querySelector(s); };
    var stage = q('[data-stage]'), phone = q('[data-phone]'), id = 'vs' + n;
    var N = backs.length;
    /* Chaque motif reste bien fixé un moment (STEP) avant le suivant. */
    var STEP = 2.9;
    var SEG = backs.map(function (b, i) { var a = i === 0 ? -9 : 1 + STEP * (i - 1) + 0.75; return { a: a, h: a + 0.75, s: a + 1.1, pe: i < N - 1 ? 1 + STEP * i : Infinity }; });
    SEG[0].h = -9; SEG[0].s = -9;
    var FIN = SEG[N - 1].s + 0.9, T = FIN + 1.6;
    var COPY = cfg.copy || [];
    var copyIndex = function (t) {
      if (t < 0.85) return 0;
      if (N > 1 && t < SEG[1].a) return 1;
      if (N > 1 && t < SEG[1].s) return 2;
      if (t < FIN) return 3;
      return 4;
    };

    var shellBox = q('[data-shell]'); shellBox.innerHTML = ''; shellBox.appendChild(shellCanvas(cfg.shell));
    var glow = document.createElement('i'); glow.className = 'ring-glow'; shellBox.appendChild(glow);
    /* Safari (Mac, iPhone, iPad) gère mal la 3D empilée : coque dessinée à plat, sans les couches d'épaisseur. */
    var FLAT = /[?&]flat3d/.test(location.search) || /^((?!chrome|chromium|android|crios|fxios|edg|opr).)*safari/i.test(navigator.userAgent) || /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (FLAT) root.classList.add('flat3d');
    FLAT_ALL = FLAT;
    /* Épaisseur réaliste (environ 13 % de la largeur) : 14 couches, bord légèrement éclairé au milieu comme un côté arrondi. */
    var DEPTH_N = 14, DEPTH_STEP = 2.4;
    q('[data-depth]').innerHTML = Array.apply(null, Array(DEPTH_N)).map(function (_, k) { var l = Math.round(20 + 20 * Math.sin(Math.PI * k / (DEPTH_N - 1))), c = k === DEPTH_N - 1 ? '#060607' : 'rgb(' + l + ',' + l + ',' + (l + 2) + ')'; return '<i style="transform:translateZ(' + (-(k + 1) * DEPTH_STEP) + 'px);background:' + c + '"></i>'; }).join('');
    var depthEls = Array.prototype.slice.call(q('[data-depth]').children);
    var platesBox = q('[data-plates]'); platesBox.innerHTML = '';
    backs.forEach(function (b, i) { var fromShell = i === 0 && cfg.shellHasBack; var d = document.createElement('div'); d.className = 'plate'; d.appendChild(plateCanvas(fromShell ? cfg.shell : b.img, fromShell || !!b.full)); platesBox.appendChild(d); });
    q('[data-dots]').innerHTML = backs.map(function (b, i) { return '<button type="button" data-i="' + i + '" aria-label="' + esc(b.name) + '" title="' + esc(b.name) + '" style="background-image:url(\'' + esc(b.img) + '\')"></button>'; }).join('');
    q('[data-total]').textContent = '/ ' + String(N).padStart(2, '0');
    var plates = Array.prototype.slice.call(root.querySelectorAll('.plate'));

    function fanPose(i, k) {
      var others = backs.map(function (_, j) { return j; }).filter(function (j) { return j !== N - 1; });
      var j = others.indexOf(i), o = j - (others.length - 1) / 2, sp = others.length <= 3 ? 2 : 1;
      return { x: o * 30 * sp, y: 4 + Math.abs(o) * 4 * sp - (o === 0 ? 14 : 0), z: -170, rx: 0, ry: 0, rz: o * 13 * sp, o: k };
    }
    function poseFor(i, t) {
      var s = SEG[i];
      if (i < N - 1 && t >= FIN) { var kf = easeOut(clamp((t - FIN) / 1)); return kf > 0 ? fanPose(i, kf) : null; }
      if (i > 0 && t < s.a) return null;
      if (i > 0 && t < s.h) { var k1 = (t - s.a) / (s.h - s.a); var p = lerp(POSE.FROM, POSE.HOVER, easeOut(k1)); p.o = clamp(k1 * 3); return p; }
      if (i > 0 && t < s.s) return lerp(POSE.HOVER, POSE.ATT, easeIn((t - s.h) / (s.s - s.h)));
      if (t < s.pe) return POSE.ATT;
      var k = (t - s.pe) / 0.75; if (k >= 1) return null;
      return k < 0.45 ? lerp(POSE.ATT, POSE.LIFT, easeOut(k / 0.45)) : lerp(POSE.LIFT, POSE.AWAY, easeIn((k - 0.45) / 0.55));
    }
    function moodAt(t) {
      if (t < 0.3) return hexRGB(cfg.introMood);
      if (t < 0.9) return mix(cfg.introMood, backs[0].mood, smooth((t - 0.3) / 0.6));
      if (t >= FIN) return mix(backs[N - 1].mood, cfg.finalMood, smooth(clamp((t - FIN) / 0.8)));
      var m = hexRGB(backs[0].mood);
      for (var i = 1; i < N; i++) if (t >= SEG[i].a) m = mix(backs[i - 1].mood, backs[i].mood, smooth(clamp((t - SEG[i].a) / 0.8)));
      return m;
    }
    var lastT = 0, lastCopy = -1, lastWord = '';
    function restart(el, cls) { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }
    /* Rotation de la coque : à la fin elle se redresse doucement (presque de face), sans jamais basculer de l'autre côté, donc son contour reste stable. */
    var RY_FIN = -18 + 7 * Math.sin(FIN * 0.55), RY_END = -3;
    function caseRy(t) {
      if (t < FIN) return -58 + 40 * easeOut(clamp(t / 0.9)) + 7 * Math.sin(t * 0.55);
      return RY_FIN + (RY_END - RY_FIN) * smooth(clamp((t - FIN) / 1));
    }
    function render(t) {
      plates.forEach(function (el, i) {
        var p = poseFor(i, t);
        /* Éventail final (3D) : la coque reste tournée, on recentre les motifs placés derrière elle. */
        if (p && !FLAT_ALL && p.z < -1) { var ryEnd = caseRy(t) * Math.PI / 180; p = Object.assign({}, p, { x: p.x - p.z * Math.tan(ryEnd) / Math.max(phone.offsetWidth, 1) * 100 }); }
        if (!p || p.o <= 0.01) { el.style.visibility = 'hidden'; return; }
        el.style.visibility = 'visible'; el.style.opacity = p.o.toFixed(3);
        el.style.transform = plateTransform(p);
        if (FLAT_ALL) el.style.zIndex = String((p.z < -1 ? -2000 : 1000) + Math.round(p.z)); /* derrière la coque quand le motif est derrière */
      });
      var attached = SEG.some(function (s, i) { return (i === 0 ? t >= -1 : t >= s.s) && t < s.pe + 0.05; });
      glow.style.opacity = attached ? '0' : '1';
      q('[data-field]').classList.toggle('on', SEG.some(function (s, i) { return i > 0 && t >= s.a + 0.3 && t < s.s; }));
      var cur = 0; SEG.forEach(function (s, i) { if (i === 0 || t >= s.a) cur = i; });
      var b = backs[cur];
      q('[data-name]').textContent = b.name;
      var link = q('[data-link]'); link.href = b.url || '#'; link.hidden = !b.url;
      q('[data-num]').textContent = String(cur + 1).padStart(2, '0');
      Array.prototype.forEach.call(root.querySelectorAll('[data-dots] button'), function (d, i) { d.setAttribute('aria-current', String(i === cur)); });
      var m = moodAt(t), lum = (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255;
      stage.style.setProperty('--mood', 'rgb(' + m.join(',') + ')'); stage.style.setProperty('--mood-ink', lum < 0.5 ? '#FFF8EC' : '#21170C');
      var word = t < 0.85 || t >= FIN + 0.4 ? 'VIMA' : (b.word || b.name).toUpperCase();
      var bw = q('[data-bigword]');
      if (word !== lastWord) { lastWord = word; bw.textContent = word; restart(bw, 'swap'); }
      bw.style.transform = 'translateX(' + (6 - ((t % 2) / 2) * 14).toFixed(2) + 'vw)';
      var ci = copyIndex(t);
      if (ci !== lastCopy && COPY[ci]) {
        lastCopy = ci; var h = q('[data-title]'), p = q('[data-text]');
        h.textContent = COPY[ci][0]; p.textContent = COPY[ci][1]; restart(h, 'swap'); restart(p, 'swap');
        q('[data-cta]').classList.toggle('show', ci === 4); q('[data-copy]').classList.toggle('final', ci === 4);
      }
      q('[data-hint]').style.opacity = t < 0.35 ? '0.8' : '0';
      var intro = easeOut(clamp(t / 0.9));
      var ry = caseRy(t), fin = smooth(clamp((t - FIN) / 1));
      phone.style.transform = 'rotateY(' + ry.toFixed(2) + 'deg) rotateX(' + (8 - 5 * fin).toFixed(2) + 'deg) rotateZ(' + (-2 + 2 * fin).toFixed(2) + 'deg) scale(' + (0.86 + 0.14 * intro).toFixed(3) + ')';
      /* Mode Safari : l'épaisseur est dessinée à plat, en décalant les couches sur le côté selon la rotation. */
      if (FLAT) flatDepth(depthEls, phone.offsetWidth, ry);
      SEG.forEach(function (s, i) {
        if (i > 0 && lastT < s.s && t >= s.s) {
          restart(q('[data-pulse]'), 'go'); restart(phone, 'jolt');
        }
      });
      lastT = t;
    }
    var headH = function () { var h = document.querySelector('.top'); return h ? h.offsetHeight : 0; };
    var staticT = 0.6;
    function tick() {
      if (STILL) { render(staticT); return; }
      var total = root.offsetHeight - stage.offsetHeight;
      var p = clamp((headH() - root.getBoundingClientRect().top) / Math.max(total, 1));
      q('[data-bar]').style.width = (p * 100).toFixed(1) + '%';
      render(p * T);
    }
    var holdT = function (i) { return i === 0 ? 0.6 : SEG[i].s + 0.35; };
    if (STILL) root.classList.add('static'); else root.style.setProperty('--story-h', (T * 55) + 'vh');
    var setHead = function () { document.documentElement.style.setProperty('--head', headH() + 'px'); };
    setHead(); tick();
    var ticking = false;
    window.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; tick(); }); }, { passive: true });
    window.addEventListener('resize', function () { setHead(); tick(); });
    q('[data-dots]').addEventListener('click', function (e) {
      var btn = e.target.closest('[data-i]'); if (!btn) return; var i = +btn.getAttribute('data-i');
      if (STILL) { staticT = holdT(i); lastT = staticT; tick(); return; }
      var total = root.offsetHeight - stage.offsetHeight, top = root.getBoundingClientRect().top + window.scrollY - headH();
      window.scrollTo({ top: top + holdT(i) / T * total, behavior: 'smooth' });
    });
    root.addEventListener('click', function (e) {
      var j = e.target.closest('[data-jump]'); if (!j) return;
      var target = document.querySelector(j.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: STILL ? 'auto' : 'smooth', block: 'start' }); }
    });
  }
  function start() { Array.prototype.forEach.call(document.querySelectorAll('[data-story]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
